import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';
import { selectCartCurrency, selectCartTotal } from '../../../../modules/selectors';
import { selectCartWidgetShowPrices } from '../../../../modules/widget/selectors';
import { NO_PRICE, useGetCartTotalPrice } from '../Body/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "TotalBlock-root_yXMKE"
};
export function TotalBlock() {
  const {
    formatPrice
  } = useTranslator();
  const currency = useSelector(selectCartCurrency);
  const total = useSelector(selectCartTotal);
  const prices = useSelector(selectCartWidgetShowPrices);
  const getCartTotalPrice = useGetCartTotalPrice();
  return /*#__PURE__*/_jsx("span", {
    className: styles.root,
    children: prices ? formatPrice(getCartTotalPrice(total), currency) : NO_PRICE
  });
}